/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comment_Field_LabelInputs */

const en_comment_field_label = /** @type {(inputs: Comment_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment`)
};

const ja_comment_field_label = /** @type {(inputs: Comment_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント`)
};

const fr_comment_field_label = /** @type {(inputs: Comment_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaire`)
};

const de_comment_field_label = /** @type {(inputs: Comment_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar`)
};

/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Comment_Field_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const comment_field_label = /** @type {((inputs?: Comment_Field_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comment_Field_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_comment_field_label(inputs)
	if (locale === "ja") return ja_comment_field_label(inputs)
	if (locale === "fr") return fr_comment_field_label(inputs)
	return de_comment_field_label(inputs)
});